// Dashboard stages (SPEC §2). Order matters: it is the ladder.

export const REQ_STAGES = [
  "draft",
  "awaiting_superintendent",
  "sourcing",
  "ready_to_order",
  "po_in_approval",
  "ordered",
  "partly_received",
  "received",
  "rejected",
] as const;
export type ReqStage = (typeof REQ_STAGES)[number];
/** Stages 1–7: the active pipeline. */
export const REQ_ACTIVE_STAGES = REQ_STAGES.slice(0, 7) as ReqStage[];
export const REQ_STAGE_NUMBER: Record<ReqStage, number | null> = {
  draft: 1,
  awaiting_superintendent: 2,
  sourcing: 3,
  ready_to_order: 4,
  po_in_approval: 5,
  ordered: 6,
  partly_received: 7,
  received: 8,
  rejected: null,
};

export const PO_STAGES = [
  "po_draft",
  "price_approval",
  "awaiting_placement",
  "ordered",
  "partly_received",
  "received",
  "cancelled",
] as const;
export type PoStage = (typeof PO_STAGES)[number];
export const PO_ACTIVE_STAGES: PoStage[] = ["po_draft", "price_approval", "awaiting_placement", "ordered", "partly_received"];

export const REQ_STAGE_LABEL: Record<ReqStage, string> = {
  draft: "Draft",
  awaiting_superintendent: "Awaiting technical review",
  sourcing: "RFQ",
  ready_to_order: "Ready for order",
  po_in_approval: "PO in approval",
  ordered: "Ordered",
  partly_received: "Partly received",
  received: "Fully received",
  rejected: "Rejected",
};

export const PO_STAGE_LABEL: Record<PoStage, string> = {
  po_draft: "PO draft",
  price_approval: "Price approval",
  awaiting_placement: "Awaiting placement",
  ordered: "Ordered",
  partly_received: "Partly received",
  received: "Received",
  cancelled: "Cancelled",
};

/** The status-palette slot each PO stage reuses (SPEC §2.2, §14). */
export const PO_STAGE_COLOR_SLOT: Record<PoStage, ReqStage> = {
  po_draft: "draft",
  price_approval: "po_in_approval",
  awaiting_placement: "ready_to_order",
  ordered: "ordered",
  partly_received: "partly_received",
  received: "received",
  cancelled: "rejected",
};

